<template>
    <div>
		<Dialog ref="tracingTheSourceModal" title="信息溯源" btnText="下载" :modalFoot="false" type="normal" width="1000">
			<div slot="mdBox">
				<div class="aggregate">
					<!-- 传播路径 -->
					<div class="widget-title noborder bgcolor-panel" style="height:400px;margin-top:0px;overflow: hidden;position: relative; border: 0px;background:#130d40;">
						<div id="traceRouteDiv" style="height:100%;">
							<canvas v-if="showCanvs" id="myCanvas" style="position:absolute;left:0;"></canvas>
						</div>
					</div>
					<div class="table-warp">
						<table class="table mt15" width="100%" border="0" cellpadding="0" cellspacing="0">
							<colgroup>
								<col width="5%">
								<col width="45%">
								<col width="10%">
								<col width="20%">
								<col width="20%">
							</colgroup>
							<thead>
								<tr>
									<th>序号</th>
									<th>标题</th>
									<th>媒体类型</th>
									<th>来源</th>
									<th>发布时间</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="(item,index) in list" :key="index">
									<td>{{item.id}}</td>
									<td>
										<div class="ovhidden">
                                            <a :href="item.newsUrl" target="_blank" rel="noopener noreferrer" style="color:#333">
                                                <i class="tag tag-red mr" v-if="item.id === 1">疑似首发</i><span :class="{ml5:item.id === 1}" v-html="item.newsTitle" :title="item.newsTitle"></span>
                                            </a>
										</div>
									</td>
									<td>{{item.platformName}}</td>
									<td>{{item.mediaName}}</td>
									<td>{{item.newsPosttime}}</td>
								</tr>
							</tbody>
						</table>
						<!-- 分页 -->
						<page class="mt20" :currentPage.sync="page" :limit.sync="limit" :totalCount="total" @turn="getTableData"></page>
					</div>
				</div>
			</div>
		</Dialog>
		<loading :showLoad="showLoad"></loading>
	</div>
</template>
<script>
import './jquery-ui.min.js'
import transPath from './Route_Map.js'
import Dialog from '@/components/dialog.vue'
import loading from '@/components/loading.vue'
import page from '@/components/page.vue';
export default {
    name: "tracingTheSource",
	components: {Dialog,loading,page},
    props: {
        postData: {//控制层级
            type: Object
        }
    },
    data() {
        return {
            list:[],
			page:1,
			limit:10,
			total:0,
            showLoad:false,
            showCanvs:false
        }
    },
    mounted() {
        // this.$refs.tracingTheSourceModal.showMaskFun();
    },
	watch:{
		postData(){
			this.page = 1;
			this.getList();
		}
	},
    created() {
		
    },
    methods: {
        // 获取列表
		getList (){
            this.showCanvs = false;
			let that = this;
			that.showLoad = true;
			let data = {...that.postData};
			data.page = that.page;
			data.limit = that.limit;
			that.$api.post('/monitor/info/news-pathlist',data,r =>{
                that.getPath();
                this.showCanvs = true;
				that.list = r.data.list;
				that.total = r.data.total;
			})
		},
		getTableData () {
			let that = this;
			that.getList();
		},
		// 获取文章路劲数据
		getPath (){
			let that = this;
			that.$api.post('monitor/info/news-path',that.postData,r =>{
				let category = r.data.data.timeLine;
                let data = r.data.data.transList;
				let originItem = r.data.data.originItem;
				transPath.mediaTypeColor = r.data.data.mediaColorList;
				transPath.mediaTypeName = r.data.data.mediaList;
				transPath.mediaTypeOrder =  r.data.data.mediaListKey;//图例顺序
                transPath.mediaTypeIDs =  r.data.data.mediaListKeyIndex;
                that.showLoad = false;
				that.$refs.tracingTheSourceModal.showMaskFun();
				setTimeout(() =>{
                    $("#traceRouteDiv").draggable({
                        axis: "x",
                    });
                    transPath.initCanvas(originItem,category,data);
				},100)
			})
		},
		transAjax(){//传播分析
			
			transPath.mediaTypeColor = {
				0:"#16A79D",//website
				1:"#F7624A",//printedMedia
				2:"#80628B",//App
				3:"#DD547A",//BBS
				4:"#CF4858",//weixin
				5:"#68B1CB",//weibo
				6:"#F5AD42",//wemedia
			};
			transPath.mediaTypeName = {
				0:"网站",//website
				1:"电子报纸",//printedMedia
				2:"App",//App
				3:"论坛",//BBS	
				4:"微信",//weixin
				5:"微博",//weibo
				6:"自媒体",//wemedia
			}
			transPath.mediaTypeOrder=[0,1,2,4,5,3,6];//图例顺序
			
			that.category = ["2020-04-18 20","2020-04-18 21","2020-04-18 22","2020-04-18 23","2020-04-19 00","...","2020-04-19 09","2020-04-19 10","2020-04-19 11","2020-04-19 12","2020-04-19 13","2020-04-19 14","2020-04-19 15","2020-04-19 16","2020-04-19 17","2020-04-19 18","2020-04-19 19","2020-04-19 20","2020-04-19 21","2020-04-19 22","2020-04-19 23","2020-04-20 00","2020-04-20 01","2020-04-20 02","2020-04-20 03","2020-04-20 04","2020-04-20 05","2020-04-20 06","2020-04-20 07","2020-04-20 08","2020-04-20 09","2020-04-20 10","2020-04-20 11","2020-04-20 12","2020-04-20 13","2020-04-20 14","2020-04-20 15","2020-04-20 16","2020-04-20 17","2020-04-20 18","2020-04-20 19","2020-04-20 20","2020-04-20 21","2020-04-20 22","2020-04-20 23","2020-04-21 00","...","2020-04-21 08","2020-04-21 09","2020-04-21 10","2020-04-21 11","2020-04-21 12","2020-04-21 13","2020-04-21 14","2020-04-21 15","2020-04-21 16","2020-04-21 17","2020-04-21 18","2020-04-21 19","2020-04-21 20"];
			//[name,tracedCount(跟踪计数),px( x轴位置 data一维数组的key),py(Y轴的父级的位置二维数组的key),childCount(当前有几个子级),weight(这个重量不知道啥意思),pHours（中间线条上面的时间）,mediaType（媒体类型）,webUrl（新闻地址）,source（来源）,postTime（发布时间）] px:-1;py:-1表示没有父节点
			that.data = [
				
				[
					["澎湃新闻 - 一点资讯", 0, -1, -1, 0, 0, 0, 6, "http://www.yidianzixun.com/article/0PD9VsNu", "", "2020-04-24 18:21"]
				],
				[],
				[
					["人民网", 0, -1, -1, 2, 0, 1, 1, "http://legal.people.com.cn/n1/2020/0424/c42510-31687296.html", "人民网", "2020-04-24 20:05"],
					["中国新闻网", 0, -1, -1, 6, 0, 1, 1, "http://www.chinanews.com/gn/2020/04-24/9167057.shtml", "中国新闻网", "2020-04-24 20:18"],
					["凤凰网", 0, 2, 1, 0, 0, 0, 0, "http://news.ifeng.com/c/7vwDcK1fatG", "中国新闻网", "2020-04-24 20:18"],
					["凤凰新闻客户端", 0, 2, 1, 0, 0, 0, 2, "https://news.ifeng.com/c/7vwDcK1fatG", "中国新闻网", "2020-04-24 20:18"],
					["新浪", 0, 2, 1, 0, 0, 0, 0, "https://news.sina.com.cn/o/2020-04-24/doc-iirczymi8172717.shtml", "中国新闻网", "2020-04-24 20:18"],
					["百度", 0, 2, 1, 0, 0, 0, 0, "https://3w.huanqiu.com/a/a4d1ef/3xy7oR6vzAp?agt=8", "中国新闻网", "2020-04-24 20:30"],
					["腾讯", 0, 2, 0, 0, 0, 0, 0, "https://new.qq.com/omn/TWF20200/TWF2020042400906500.html", "人民网", "2020-04-24 20:31"],
					["网易", 0, 2, 1, 0, 0, 0, 0, "https://news.163.com/20/0424/20/FB0N9SNT0001899O.html", "中国新闻网", "2020-04-24 20:34"],
					["搜狐新闻客户端", 0, 2, 1, 0, 0, 0, 2, "https://m.sohu.com/a/390883828_114988", "中国新闻网", "2020-04-24 20:46"],
				],
				[
					["澎湃新闻客户端", 0, -1, -1, 1, 0, 0, 2, "http://m.thepaper.cn/newsDetail_forward_7122242", "澎湃新闻", "2020-04-24 21:11"]
				],
				[],
				[
					["法制网", 0, -1, -1, 0, 0, 0, 0, "http://www.legaldaily.com.cn/index_article/content/2020-04/24/content_8179764.htm", "公安部刑侦局", "2020-04-24 23:01"]
				],
				[],
				[],
				[],
				[
					["东莞去哪玩 - 一点资讯", 0, -1, -1, 0, 0, 0, 6, "http://www.yidianzixun.com/article/0PDORrKV", "", "2020-04-25 03:34"]
				],
				[],
				[
					["中国网", 0, 2, 0, 0, 0, 12, 0, "http://zw.china.com.cn/2020-04/25/content_75974085.html", "人民网", "2020-04-25 09:01"]
				],
				[],
				[],
				[
					["楚天交通广播 - 一点资讯", 0, -1, -1, 0, 0, 0, 6, "http://www.yidianzixun.com/article/0PDNhqN5", "", "2020-04-25 12:07"]
				],
				[],
				[
					["湖北网络广播电视台", 0, 2, 1, 0, 0, 17, 0, "https://news.hbtv.com.cn/p/1833601.html", "中国新闻网", "2020-04-25 14:05"]
				],
				[
					["新民网", 0, -1, -1, 0, 0, 0, 0, "http://shanghai.xinmin.cn/xmsq/2020/04/25/31716343.html", "新华网", "2020-04-25 15:33"]
				],
				[
					["凤凰资讯", 0, -1, -1, 0, 0, 0, 0, "http://news.ifeng.com/c/7vxZKRpqKsA", "新京报", "2020-04-25 16:15"],
					["魅力江西", 0, -1, -1, 0, 0, 0, 0, "http://news.jxnews.com.cn/system/2020/04/25/018865186.shtml", "央视新闻", "2020-04-25 16:22"],
					["大洋网", 0, -1, -1, 0, 0, 0, 0, "https://news.dayoo.com/society/202004/25/140000_53309646.htm", "央视新闻", "2020-04-25 16:59"],
					["新浪财经", 0, -1, -1, 0, 0, 0, 0, "http://finance.sina.com.cn/wm/2020-04-25/doc-iirczymi8292611.shtml", "参考消息", "2020-04-25 16:59"],
					["新浪新闻", 0, -1, -1, 0, 0, 0, 0, "http://mil.news.sina.com.cn/2020-04-25/doc-iirczymi8292591.shtml", "参考消息", "2020-04-25 16:59"]
				],
				[
					["澎湃新闻", 0, 3, 0, 0, 0, 20, 0, "http://www.thepaper.cn/newsDetail_forward_7137369", "澎湃新闻", "2020-04-25 17:13"],
					["厦门网", 0, -1, -1, 0, 0, 0, 0, "http://news.xmnn.cn/xmnn/2020/04/25/100711710.shtml?from=app", "央视新闻", "2020-04-25 17:41"]
				],
				[
					["唐山环渤海新闻网", 0, -1, -1, 0, 0, 0, 0, "http://news.huanbohainews.com.cn/system/2020/04/25/011907346.shtml", "人民日报", "2020-04-25 18:05"]
				],
				[]
			];
			transPath.mediaTypeIDs = [0,1,2,4,5,3,6];
			that.originItem = ["梨乡微言",2,-1,-1,0,0,0,-1,"http://mp.weixin.qq.com/s?__biz=MzU2OTAxMTgzNw==&idx=3&mid=2247485883&scene=0&sn=7fda6100526121b0a73c5bf03d1519e8&biz=MzU2OTAxMTgzNw==#wechat_redirect","2020-04-20 11:26"];
            // transPath.initCanvas(that.originItem,that.category,that.data);
            
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/page/yuqingFenxi/components/tracingTheSource.vue